import { AreaCompetenza } from "./areaCompetenza.model";

export class TipoIntervento {
    id: Number;
    label: String;
    colore: string;
    areaCompetenza:AreaCompetenza;
    deletable:Boolean;
  }
